var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "page_not_found" } }, [
    _c("section", { staticClass: "bg-cl-secondary py35 px20" }, [
      _c("div", { staticClass: "container" }, [
        _c("h3", [
          _vm._v(
            "\n        " + _vm._s(_vm.$t("We can't find the page")) + "\n      "
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "bg-cl-primary py35 px20" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-9 static-content mb20" }, [
            _c(
              "div",
              { staticClass: "h4 weight-400 pt10 not-found-content" },
              [_c("cms-block-chunk", { attrs: { identifier: "c_404_TEXT" } })],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }